import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import React from "react";
import type { PostTypeInfo } from "./postTypeLookup";
import type { DraftPreviewModel } from "../draftPreviewTypes";

type Props = {
  /** "UGC" / "Orgánica" / "MeliClips" — the campaign type picked before the chat
   * started, off `CAMPAIGN_TYPES`. Absent only before a type has been chosen. */
  campaignTypeLabel: string | undefined;
  contents: DraftPreviewModel["contents"];
  postTypes: Map<string, PostTypeInfo>;
  title: string;
};

/**
 * The eyebrow + title exactly as `TitleCard.tsx` renders it in the mobile app —
 * "UGC · Instagram, TikTok" over a two-line bold title.
 */
const HeaderBlock = React.memo(
  ({ campaignTypeLabel, contents, postTypes, title }: Props) => {
    const platforms = Array.from(
      new Set(
        contents
          .map((content) =>
            content.postTypeId
              ? postTypes.get(content.postTypeId)?.platformName
              : undefined,
          )
          .filter((name): name is string => !!name),
      ),
    );
    const eyebrowParts = [
      ...(campaignTypeLabel ? [campaignTypeLabel] : []),
      ...platforms,
    ];
    const eyebrow = eyebrowParts.length > 0 ? eyebrowParts.join(" · ") : null;

    return (
      <VStack space="xs">
        {eyebrow ? (
          <Text
            bold
            size="2xs"
            className="uppercase tracking-widest text-typography-500"
          >
            {eyebrow}
          </Text>
        ) : null}
        <Text
          bold
          className="text-typography-950 text-[22px] leading-[26px] tracking-tight"
          numberOfLines={2}
        >
          {title || "Título de la campaña"}
        </Text>
      </VStack>
    );
  },
);

HeaderBlock.displayName = "HeaderBlock";

export default HeaderBlock;
